"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _panzoom = _interopRequireDefault(require("@panzoom/panzoom"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _ResponsiveProvider = require("../../framework/ResponsiveProvider/ResponsiveProvider.index");

var _S3Visualizer = require("./S3Visualizer.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TIMER_MARK_NAME = 'vis-image-load-mark';

var S3Visualizer = function S3Visualizer(_ref) {
  var baseImageUrl = _ref.baseImageUrl,
      className = _ref.className,
      imageAlternateText = _ref.imageAlternateText,
      zoomEnabled = _ref.zoomEnabled,
      updateZoom = _ref.updateZoom,
      visualizationCallback = _ref.visualizationCallback;
  var visualizerRef = (0, _react.useRef)(null);
  var imageElement = (0, _react.useRef)(null);

  var _useBreakpoint = (0, _ResponsiveProvider.useBreakpoint)(),
      isLarge = _useBreakpoint.isLarge;

  var _useState = (0, _react.useState)(baseImageUrl),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      imageUrl = _useState2[0],
      setImageUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(baseImageUrl),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      largeImageUrl = _useState4[0],
      setLargeImageUrl = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      panzoom = _useState6[0],
      setPanzoom = _useState6[1];

  (0, _react.useEffect)(function () {
    if (zoomEnabled) {
      setImageUrl(largeImageUrl);
      panzoom === null || panzoom === void 0 ? void 0 : panzoom.zoom(4, {
        disablePan: false
      });
      panzoom === null || panzoom === void 0 ? void 0 : panzoom.setOptions({
        contain: 'outside'
      });
    } else {
      panzoom === null || panzoom === void 0 ? void 0 : panzoom.setOptions({
        contain: '',
        minScale: 1
      });
      panzoom === null || panzoom === void 0 ? void 0 : panzoom.reset();
    }
  }, [zoomEnabled, largeImageUrl, isLarge, panzoom]);
  (0, _react.useEffect)(function () {
    if (baseImageUrl) {
      (0, _autobahnUtilities.startPerformanceTimer)(TIMER_MARK_NAME); // Semi-hack to detect LP URLs and provide size/scale information correctly.

      var sinkIndex = baseImageUrl.indexOf('&sink');

      if (sinkIndex === -1) {
        var params = {
          fit: 'constrain,1',
          fmt: 'jpeg'
        };

        var imageParams = _objectSpread(_objectSpread({}, params), {}, {
          hei: 500,
          wid: 285
        });

        var largeImageParams = _objectSpread({}, params);

        setImageUrl("".concat(baseImageUrl, "?").concat((0, _autobahnUtilities.buildQuery)(imageParams)));
        setLargeImageUrl("".concat(baseImageUrl, "?").concat((0, _autobahnUtilities.buildQuery)(largeImageParams)));
      } else {
        // The split and add here is due to &sink being required as the last param.
        // Options after &sink are ignored
        setImageUrl("".concat(baseImageUrl.slice(0, sinkIndex), "&scale=size[700]&sink"));
        setLargeImageUrl(baseImageUrl);
      }
    }
  }, [baseImageUrl]);
  (0, _react.useEffect)(function () {
    if (imageElement && imageElement.current) {
      setPanzoom((0, _panzoom["default"])(imageElement.current, {
        animate: true,
        duration: 500,
        relative: false,
        bounds: true,
        minScale: 1
      }));
    }
  }, [imageElement]);
  var timingCallBack = (0, _react.useCallback)(function (success) {
    if (!zoomEnabled) {
      var measuredTimer = (0, _autobahnUtilities.endPerformanceTimer)(TIMER_MARK_NAME);

      if (baseImageUrl && measuredTimer) {
        (0, _autobahnUtilities.addNewRelicPageAction)('visualization-loaded', {
          baseImageUrl: baseImageUrl,
          success: success,
          duration: Math.round(measuredTimer.duration)
        });
      }
    }
  }, [baseImageUrl, zoomEnabled]);
  return /*#__PURE__*/_react["default"].createElement(_S3Visualizer.StyledVisualizer, {
    className: className,
    "data-id": "visualizer",
    ref: visualizerRef
  }, /*#__PURE__*/_react["default"].createElement(_S3Visualizer.StyledVisualizerRatioBox, {
    ratio: {
      width: 35,
      height: 31
    }
  }, /*#__PURE__*/_react["default"].createElement(_S3Visualizer.StyledZoomImage, {
    isZoomEnabled: zoomEnabled,
    alt: imageAlternateText,
    ref: imageElement,
    src: imageUrl,
    "data-large": largeImageUrl,
    onLoad: function onLoad() {
      visualizationCallback({
        visualized: true,
        loaded: true
      });
      timingCallBack(true);
    },
    onError: function onError() {
      visualizationCallback({
        visualized: false
      });
      updateZoom(false);
      timingCallBack(false);
    }
  })));
};

S3Visualizer.defaultProps = {
  baseImageUrl: null,
  className: null,
  zoomEnabled: false,
  updateZoom: _noop2["default"],
  visualizationCallback: _noop2["default"]
};
S3Visualizer.propTypes = {
  /** Image alternate text */
  imageAlternateText: _propTypes.string.isRequired,

  /** Visualization Image to render without arguments */
  baseImageUrl: _propTypes.string,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** If true, the visualizer will render a zoomed version of the Image */
  zoomEnabled: _propTypes.bool,

  /** If a state change in visualization (e.g. broken image) needs to update zoom it uses this callback */
  updateZoom: _propTypes.func,

  /** Callback for when viewer interaction or state needs to update the container */
  visualizationCallback: _propTypes.func
};
S3Visualizer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "S3Visualizer",
  "props": {
    "baseImageUrl": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Visualization Image to render without arguments",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "zoomEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the visualizer will render a zoomed version of the Image",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "updateZoom": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "If a state change in visualization (e.g. broken image) needs to update zoom it uses this callback",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "visualizationCallback": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Callback for when viewer interaction or state needs to update the container",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "imageAlternateText": {
      "description": "Image alternate text",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(S3Visualizer);

exports["default"] = _default;